import { Component, inject, ViewChild } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AbstractControl, FormBuilder, FormGroup, ReactiveFormsModule, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { profileService } from '../Services/profile.service';
import { Router } from '@angular/router';
import { ToasterComponent } from "../../../shared/Componet/toaster/toaster.component";
import { CommonModule } from '@angular/common';
import { countries } from '../../../shared/Model/countries-store';
import { ChangeEmailComponent } from "../change-email/change-email.component";
import { imageService } from '../../../shared/service/image.service';

@Component({
  selector: 'app-profile',
  imports: [TranslateModule, ReactiveFormsModule, ToasterComponent, CommonModule, ChangeEmailComponent],
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.css'
})
export class ProfileComponent {
  errorMessage: string | null = null;
  ProfileForm!: FormGroup;
  showToast = false;
  toastMessage = '';
  toastType: 'success' | 'error' = 'success';
  id: number | null = null;
  showPassword: boolean = false;
  showConfirmPassword: boolean = false;
  private subs = new Subscription();   // container for all subscriptions
  roles: any;
  public countries: any = countries;

  private fb = inject(FormBuilder);
  private translate = inject(TranslateService)
  private router = inject(Router);
  private imageService = inject(imageService)
  private profileService = inject(profileService)

  selectedFile!: File | null;
  previewUrl: string | ArrayBuffer | null = null;
  selectedCountry: any = "";


  // phoneLengthValidator(minLength: number): ValidatorFn {
  //   return (control: AbstractControl): ValidationErrors | null => {
  //     const value = control.value?.toString() || '';
  //     return value.length < minLength ? { minlength: true } : null;
  //   };
  // }

  internationalPhoneValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) return null;

      // لازم يبدأ بـ + ورقم دولة وبعده رقم
      const regex = /^\d{10,14}$/;

      return regex.test(control.value)
        ? null
        : { invalidPhoneCode: true };
    };
  }


  ngOnInit(): void {
    this.ProfileForm = this.fb.group({
      FirstName: [''],
      LastName: [''],
      Nationality: [''],
      IdNumber: [{ value: '', disabled: true }],
      BirthDate: [new Date('2000-01-01').toISOString()],
      Username: ['', [Validators.pattern(/^[a-zA-Z0-9._@-]+$/)]],
      Email: [{ value: '', disabled: true }],
      PhoneNumber: ['', this.internationalPhoneValidator()],
      Job: [''],
    });

    this.reloadUserData()

  }


  reloadUserData() {
    this.id = +localStorage.getItem('userId')!;  // assuming userId is stored in localStorage
    this.profileService.GetUserData(this.id).subscribe({
      next: (res: any) => {
        const birthDate = new Date(res.value.birthDate);
        this.ProfileForm.patchValue({
          id: res.value.id,
          FirstName: res.value.firstName,
          LastName: res.value.lastName,
          Nationality: res.value.nationality,
          Email: res.value.email,
          Username: res.value.userName,
          PhoneNumber: res.value.phoneNumber,
          Job: res.value.job,
          IdNumber: res.value.idNumber,
          BirthDate: birthDate
            ? this.formatDate(birthDate)
            : '', // dd-MM-yyyy 
          roles: res.value.roles
        })
        this.roles = res.value.roles;
        this.profileService.GetUserImag(res.value.userName).subscribe({
          next: (blob: Blob) => {
            this.previewUrl = URL.createObjectURL(blob);
            // console.log("Image URL:", this.previewUrl);
          }
        })
      }
    })
  }


  matchPasswordValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.parent) return null; // لسه الفورم ما اتبناش

      const password = control.parent.get('password')?.value;
      const confirm = control.value;

      if (!password || !confirm) return null;

      return password === confirm ? null : { passwordMismatch: true };
    };
  }


  togglePassword() {
    this.showPassword = !this.showPassword;
  }

  toggleConfirmPassword() {
    this.showConfirmPassword = !this.showConfirmPassword;
  }


  onSubmit(): void {
    this.ProfileForm.markAllAsTouched();


    if (this.ProfileForm.valid) {
      const payload = {
        firstName: this.ProfileForm.get("FirstName")?.value,
        lastName: this.ProfileForm.get("LastName")?.value,
        username: this.ProfileForm.get("Username")?.value,
        nationality: this.ProfileForm.get("Nationality")?.value,
        phoneNumber: this.ProfileForm.get("PhoneNumber")?.value,
        birthDate: this.formatDate(new Date(this.ProfileForm.get("BirthDate")?.value)),
        job: this.ProfileForm.get("Job")?.value
      }


      const sub = this.profileService.UpdateUserData(payload).subscribe({
        next: (response: any) => {
          // console.log("API response:", response.succeeded);
          if (response.succeeded) {
            // console.log("succeeded");
            this.toastType = 'success';
            this.toastMessage = "successfully updated profile";
            this.showToast = true;
            setTimeout(() => this.showToast = false, 3000);
          }
          else {
            this.toastType = 'error';
            this.toastMessage = response.errors[0];
            this.showToast = true;
            setTimeout(() => this.showToast = false, 3000);
          }
        },
        error: (err) => {
          // console.log("error");
          this.toastType = 'error';
          this.toastMessage = "error updating profile";
          this.showToast = true;
          setTimeout(() => this.showToast = false, 3000);
        }
      });
      this.subs.add(sub);
    }
  }



  // onFileSelected(event: any) {
  //   const file = event.target.files[0];
  //   if (file) {
  //     this.selectedFile = file;

  //     // عرض الصورة قبل الرفع
  //     const reader = new FileReader();
  //     reader.onload = () => this.previewUrl = reader.result;
  //     reader.readAsDataURL(file);
  //   }
  // }


  onFileSelected(event: any) {
    const file = event.target.files[0];
    if (!file) return;

    this.selectedFile = file;

    // preview
    const reader = new FileReader();
    reader.onload = () => this.previewUrl = reader.result;
    reader.readAsDataURL(file);
    // upload
    const formData = new FormData();
    formData.append("Image", file);
    formData.append("UserId", this.id?.toString() || "");
    formData.append("UserName", this.ProfileForm.get('Username')?.value);

    this.profileService.changeImage(formData).subscribe({
      next: (res: any) => {
        if (res.succeeded) {
          this.toastType = 'success';
          this.toastMessage = this.translate.instant('CHANGE.SUCCESS_CHANGE_USER_IMAGE');
          this.imageService.loadUserImage(this.ProfileForm.get('Username')?.value);
        } else {
          this.toastType = 'error';
          this.toastMessage = res.errors[0];
        }
        this.showToast = true;
        setTimeout(() => this.showToast = false, 3000);
      },
      error: () => {
        this.toastType = 'error';
        this.toastMessage = this.translate.instant('CHANGE.ERROR_CHANGE_USER_IMAGE');
        this.showToast = true;
        setTimeout(() => this.showToast = false, 3000);
      }
    });
  }


  // changeEmail() {
  //   this.profileService.SendCodeOfChangeEmail(this.ProfileForm.get('Email')?.value).subscribe({
  //     next: (response: any) => {
  //       // console.log("API response:", response.succeeded);
  //       if (response.succeeded) {
  //         // console.log("succeeded");
  //         this.toastType = 'success';

  //         this.toastMessage = this.translate.instant('CONFIRMATION.SUCCESS_SEND_CODE');
  //         this.showToast = true;
  //         setTimeout(() => this.showToast = false, 3000);
  //       }
  //       else {
  //         this.toastType = 'error';
  //         this.toastMessage = response.errors[0];
  //         this.showToast = true;
  //         setTimeout(() => this.showToast = false, 3000);
  //       }
  //     },
  //     error: (err) => {
  //       // console.log("error");
  //       this.toastType = 'error';
  //       this.toastMessage = this.translate.instant('CONFIRMATION.ERROR_SEND_CODE');;
  //       this.showToast = true;
  //       setTimeout(() => this.showToast = false, 3000);
  //     }

  //   })
  // }

  changeFirstName() {
    this.profileService.changeFirstName({
      email: this.ProfileForm.get('Email')?.value,
      userId: this.id,
      firstName: this.ProfileForm.get('FirstName')?.value
    }).subscribe({
      next: (response: any) => {
        if (response.succeeded) {
          this.toastType = 'success';

          this.toastMessage = this.translate.instant('CHANGE.SUCCESS_CHANGE_FIRST_NAME');
          this.showToast = true;
          setTimeout(() => this.showToast = false, 3000);
        }
        else {
          this.toastType = 'error';
          this.toastMessage = response.errors[0];
          this.showToast = true;
          setTimeout(() => this.showToast = false, 3000);
        }
      },
      error: (err) => {
        // console.log("error");
        this.toastType = 'error';
        this.toastMessage = this.translate.instant('CHANGE.ERROR_CHANGE_FIRST_NAME');;
        this.showToast = true;
        setTimeout(() => this.showToast = false, 3000);
      }
    })
  }

  changeLastName() {
    this.profileService.changeLastName({
      email: this.ProfileForm.get('Email')?.value,
      userId: this.id,
      lastName: this.ProfileForm.get('LastName')?.value
    }).subscribe({
      next: (response: any) => {
        if (response.succeeded) {
          this.toastType = 'success';

          this.toastMessage = this.translate.instant('CHANGE.SUCCESS_CHANGE_LAST_NAME');
          this.showToast = true;
          setTimeout(() => this.showToast = false, 3000);
        }
        else {
          this.toastType = 'error';
          this.toastMessage = response.errors[0];
          this.showToast = true;
          setTimeout(() => this.showToast = false, 3000);
        }
      },
      error: (err) => {
        // console.log("error");
        this.toastType = 'error';
        this.toastMessage = this.translate.instant('CHANGE.ERROR_CHANGE_LAST_NAME');;
        this.showToast = true;
        setTimeout(() => this.showToast = false, 3000);
      }
    })
  }

  @ViewChild('fileInput') fileInput: any;

  triggerImageUpload() {
    this.fileInput.nativeElement.click();
  }


  // onChangeProfileImage(event: any) {
  //   const file = event.target.files[0];
  //   if (!file) return;

  //   const formData = new FormData();
  //   formData.append("Image", file);
  //   formData.append("UserId", this.id?.toString() || "");
  //   formData.append("UserName", this.ProfileForm.get('Username')?.value);

  //   this.profileService.changeImage(formData).subscribe({
  //     next: (res: any) => {
  //       if (res.succeeded) {
  //         this.toastType = 'success';
  //         this.toastMessage = this.translate.instant('CHANGE.SUCCESS_CHANGE_USER_IMAGE');
  //         this.showToast = true;
  //         setTimeout(() => this.showToast = false, 3000);
  //         // تحديث المعاينة بعد الرفع
  //         const reader = new FileReader();
  //         reader.onload = () => this.previewUrl = reader.result;
  //         reader.readAsDataURL(file);
  //       } else {
  //         this.toastType = 'error';
  //         this.toastMessage = res.errors[0];
  //         this.showToast = true;
  //         setTimeout(() => this.showToast = false, 3000);
  //       }
  //     },
  //     error: () => {
  //       this.toastType = 'error';
  //       this.toastMessage = this.translate.instant('CHANGE.ERROR_CHANGE_USER_IMAGE');
  //       this.showToast = true;
  //       setTimeout(() => this.showToast = false, 3000);
  //     }
  //   });
  // }

  get f() {
    return this.ProfileForm.controls;
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();   // unsubscribe from all
  }

  formatDate(date: Date): string {
    const day = ('0' + date.getDate()).slice(-2);
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  }
}
